import { Checkbox, Stack, Text } from '@mantine/core'

import { FormatKey } from '#layouts/Script/buildFormatStyles'
import { ILoadedScript } from '#state'
import { BlockOverrides, FormatBlockName, FormatOption } from '#util/formats'

import { BulkChangeHandler } from './helpers'

import styles from './FormattingCheckboxes.module.scss'

// See (../readme.md)
// oxlint-disable-next-line react/only-export-components
export const StyleCheckboxData: {
  id: FormatKey
  label: string
  className: string
}[] = [
  { id: 'bold', label: 'Bold', className: styles.cb_bold },
  { id: 'italic', label: 'Italic', className: styles.cb_italic },
  { id: 'underline', label: 'Underline', className: styles.cb_underline },
  { id: 'uppercase', label: 'All caps', className: styles.cb_caps },
]

export const FormattingCheckboxes = ({
  script,
  pendingOverrides,
  selectedBlock,
  onChange,
}: {
  script: ILoadedScript
  pendingOverrides: BlockOverrides
  selectedBlock: FormatBlockName
  onChange: BulkChangeHandler
}) => {
  return (
    <Stack gap={2}>
      <Text fw="bold">Style</Text>
      <Stack className={styles.styleBox} gap={2}>
        {StyleCheckboxData.map((m) => {
          const pendingValue = pendingOverrides[selectedBlock]?.[m.id]
          const currentValue = script.currentFormatValue(selectedBlock, m.id)
          const value = pendingValue ?? currentValue
          const originalValue = script.originalFormatValue(selectedBlock, m.id)
          const isOverridden = value !== originalValue

          return (
            <Checkbox
              key={m.id}
              label={m.label}
              className={m.className}
              checked={!!(pendingValue ?? currentValue)}
              onChange={(e) =>
                onChange(selectedBlock, {
                  [m.id]: e.target.checked,
                } as Record<FormatOption, boolean>)
              }
              data-dirty={isOverridden}
            />
          )
        })}
      </Stack>
    </Stack>
  )
}
